import { Badge } from '@/components/ui/badge';
import { CheckCircle2, Clock, Loader2, XCircle, AlertTriangle, FileQuestion } from 'lucide-react';
import { cn } from '@/lib/utils';

const STATUS_CONFIG: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline'; icon: React.ElementType; className?: string }> = {
  Completed: { label: 'Aktiv', variant: 'default', icon: CheckCircle2, className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' },
  CompletedWithoutEmbeddings: { label: 'Aktiv (ohne Embeddings)', variant: 'default', icon: CheckCircle2, className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400' },
  Processing: { label: 'In Verarbeitung', variant: 'secondary', icon: Loader2, className: 'animate-pulse' },
  Parsing: { label: 'In Verarbeitung', variant: 'secondary', icon: Loader2, className: 'animate-pulse' },
  Parsed: { label: 'In Verarbeitung', variant: 'secondary', icon: Loader2, className: 'animate-pulse' },
  Extracting: { label: 'In Verarbeitung', variant: 'secondary', icon: Loader2, className: 'animate-pulse' },
  Uploaded: { label: 'In Verarbeitung', variant: 'outline', icon: Clock },
  AwaitingConfirmation: { label: 'Review', variant: 'outline', icon: Clock },
  Failed: { label: 'Fehler', variant: 'destructive', icon: XCircle },
  PartiallyFailed: { label: 'Teilfehler', variant: 'destructive', icon: AlertTriangle, className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400' },
  EmptyDocument: { label: 'Leer', variant: 'outline', icon: FileQuestion },
  Deleted: { label: 'Entfernt', variant: 'outline', icon: XCircle, className: 'opacity-60' },
};

export function getDocumentStatusPresentation(status: string) {
  return STATUS_CONFIG[status] ?? { label: status, variant: 'outline' as const, icon: FileQuestion };
}

interface DocumentStatusBadgeProps {
  status: string;
}

export function DocumentStatusBadge({ status }: DocumentStatusBadgeProps) {
  const config = getDocumentStatusPresentation(status);
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={cn('gap-1', config.className)}>
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
}
